import FJLocalStore from "../../../store/FJLocalStore";
import FJPageHeader from "fj-components/FJPageHeader";
import React from "react";
import styles from './FJCommonPageHeader.module.less'

function FJCommonPageHeader(props) {

  let {
    children,
    title,
    onMore,
    render = () => {}
  } = props;

  return (
    <FJPageHeader title={title}
                  onClick={onMore}
                  seeAllText={FJLocalStore._('see-all')}
									hasIcon={false}
                  classes={{
                    listBox: styles.list_box,
                    seeAllBox: styles.more_animation_box,
                    titleBox: styles.text_animation_box,
                    moreBox: styles.more_box,
                    headerBox: styles.page_header_box
                  }}
    >
      {render()}
      {children}
    </FJPageHeader>
  );
}

export default FJCommonPageHeader;